import React from "react";
import {type PEPieData} from "@components/chart/types";
import Chart from "react-apexcharts";


export interface ProgrammeExplorerPieChartProps {
  data: PEPieData[]
}
const ProgrammeExplorerPieChart: React.FC<ProgrammeExplorerPieChartProps> = ({data, children}) => {

  const labels = data.map((element: PEPieData) => element.name);
  const values = data.map((element: PEPieData) => element.data);
  const colors = data.map((element: PEPieData) => element.color);

  return (
    <>
      {
        data.length > 0 ?
          (<Chart
            type={'pie'}
            height={300}
            series={values}
            options={{
              chart: {
                id: 'realtime',
                height: 150,
                zoom: {
                  enabled: false
                },
                animations: {
                  enabled: true,
                  easing: 'linear',
                  dynamicAnimation: {
                    speed: 1000
                  }
                },
                toolbar: {
                  show: false
                },
              },
              colors: colors,
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        show: false,
                        fontSize: "25",
                        color: "#587d99",
                        fontWeight: "bold"
                      }
                    },
                  }
                }
              },
              labels: labels,
              dataLabels: {
                enabled: true
              },
              stroke: {
                curve: 'smooth',
                colors: ['primary']
              },
              fill: {
                opacity: 1,
                type: ['solid'],
              },
              markers: {
                size: 0
              },
              grid: {
                show: false
              },
              legend: {
                show: true,
                position: 'bottom'
              }
            }}>
          </Chart>)
          : null
      }

      {children}
    </>
  )
}

export default ProgrammeExplorerPieChart